import React from "react";
import { BiGroup } from "react-icons/bi";
import parse from "react-html-parser";
import { getInputTypeLabel } from "../data";
import "./Results/resultsComponents.css";

// Renders the figma-styled question header (order chip + eyebrow + title +
// respondents line) for any question card in the by-question results view,
// including TEXT questions. TEXT cards also render a `TriviaInsightsV2` body,
// but that component's own header is suppressed (via hideHeader) so this stays
// the single header for every question type.
//
// Props:
//   question           — question object (uses order, question_text, question_type, theme_settings)
//   responseCount      — number of respondents for this question
//   totalRespondents   — total people who could have answered

const buildEyebrow = (questionType) => {
  const label = getInputTypeLabel(questionType);
  if (questionType === "TEXT") {
    return label ? `OPEN-ENDED · ${label.toUpperCase()}` : "OPEN-ENDED";
  }
  if (label) {
    return `CLOSED-ENDED · ${label.toUpperCase()}`;
  }
  return "";
};

const TriviaQuestionHeader = ({ question, responseCount, totalRespondents }) => {
  if (!question) return null;

  const order = question.order;
  const orderNum = typeof order === "number" ? order : parseInt(order, 10);
  const oddOrEve = !isNaN(orderNum) && orderNum % 2 === 0 ? "even" : "odd";

  const respCount = typeof responseCount === "number" ? responseCount : 0;
  const totalResp = typeof totalRespondents === "number" ? totalRespondents : 0;
  const responseRate = totalResp > 0 ? Math.round((respCount / totalResp) * 100) : 0;

  const eyebrow = buildEyebrow(question.question_type);

  return (
    <div className="tiv2_header tiv2_header_standalone">
      <div
        className={`TriviaEditViewListUI_leftContainer_singleQuestion_chip_color_${oddOrEve} tiv2_order_chip`}
        style={
          question.theme_settings
            ? {
                backgroundColor: question.theme_settings.quizBackgroundColor,
                color: question.theme_settings.quizTextColor,
              }
            : {}
        }
      >
        <span>{order}</span>
      </div>
      <div className="tiv2_header_text">
        {eyebrow && <div className="tiv2_eyebrow">{eyebrow}</div>}
        <h4 className="tiv2_title">{parse(question.question_text || "")}</h4>
        <div className="tiv2_respondents">
          <BiGroup size={16} />
          <span>
            {respCount} of {totalResp} respondents · {responseRate}% response rate
          </span>
        </div>
      </div>
    </div>
  );
};

export default TriviaQuestionHeader;
